/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './c-pages/__root'
import { Route as AuthRouteImport } from './c-pages/_auth'
import { Route as R503RouteImport } from './c-pages/503'
import { Route as R403RouteImport } from './c-pages/403'
import { Route as TvLayoutRouteImport } from './c-pages/tv/layout'
import { Route as ExpedicaoLayoutRouteImport } from './c-pages/expedicao/layout'
import { Route as AppLayoutRouteImport } from './c-pages/app/layout'
import { Route as IndexRouteImport } from './c-pages/index'
import { Route as TvIndexRouteImport } from './c-pages/tv/index'
import { Route as ExpedicaoIndexRouteImport } from './c-pages/expedicao/index'
import { Route as AppIndexRouteImport } from './c-pages/app/index'
import { Route as AppPerfilLayoutRouteImport } from './c-pages/app/perfil/layout'
import { Route as AppLogsLayoutRouteImport } from './c-pages/app/logs/layout'
import { Route as AppCheckinLayoutRouteImport } from './c-pages/app/checkin/layout'
import { Route as AppCaminhaoLayoutRouteImport } from './c-pages/app/caminhao/layout'
import { Route as AppPerfilIndexRouteImport } from './c-pages/app/perfil/index'
import { Route as AppLogsIndexRouteImport } from './c-pages/app/logs/index'
import { Route as AppFilaIndexRouteImport } from './c-pages/app/fila/index'
import { Route as AppComoChegarIndexRouteImport } from './c-pages/app/como-chegar/index'
import { Route as AppCheckinIndexRouteImport } from './c-pages/app/checkin/index'
import { Route as AppCaminhaoIndexRouteImport } from './c-pages/app/caminhao/index'
import { Route as AppAgendamentoIndexRouteImport } from './c-pages/app/agendamento/index'
import { Route as AppPerfilEditarRouteImport } from './c-pages/app/perfil/editar'
import { Route as AppPainelFilaRouteImport } from './c-pages/app/painel/fila'
import { Route as AppLogsHistoricoRouteImport } from './c-pages/app/logs/historico'
import { Route as AppLogsExpiradosRouteImport } from './c-pages/app/logs/expirados'
import { Route as AppCaminhaoNovoRouteImport } from './c-pages/app/caminhao/novo'
import { Route as AppAgendamentoStatusRouteImport } from './c-pages/app/agendamento/status'
import { Route as AuthExpedicaoLoginRouteImport } from './c-pages/_auth/expedicao.login'
import { Route as AuthAppLoginRouteImport } from './c-pages/_auth/app.login'
import { Route as AppCaminhaoEditarIndexRouteImport } from './c-pages/app/caminhao/editar/index'
import { Route as AprovarTermoEmpresaCompanyIdDriverIdRouteImport } from './c-pages/aprovar-termo/empresa.$companyId.$driverId'
import { Route as AppCaminhaoEditarIdRouteImport } from './c-pages/app/caminhao/editar/$id'
import { Route as AuthAppRegistroIdRouteImport } from './c-pages/_auth/app.registro.$id'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const R503Route = R503RouteImport.update({
  id: '/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const TvLayoutRoute = TvLayoutRouteImport.update({
  id: '/tv',
  path: '/tv',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpedicaoLayoutRoute = ExpedicaoLayoutRouteImport.update({
  id: '/expedicao',
  path: '/expedicao',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLayoutRoute = AppLayoutRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TvIndexRoute = TvIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TvLayoutRoute,
} as any)
const ExpedicaoIndexRoute = ExpedicaoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExpedicaoLayoutRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppPerfilLayoutRoute = AppPerfilLayoutRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppLogsLayoutRoute = AppLogsLayoutRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppCheckinLayoutRoute = AppCheckinLayoutRouteImport.update({
  id: '/checkin',
  path: '/checkin',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppCaminhaoLayoutRoute = AppCaminhaoLayoutRouteImport.update({
  id: '/caminhao',
  path: '/caminhao',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppPerfilIndexRoute = AppPerfilIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPerfilLayoutRoute,
} as any)
const AppLogsIndexRoute = AppLogsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLogsLayoutRoute,
} as any)
const AppFilaIndexRoute = AppFilaIndexRouteImport.update({
  id: '/fila/',
  path: '/fila/',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppComoChegarIndexRoute = AppComoChegarIndexRouteImport.update({
  id: '/como-chegar/',
  path: '/como-chegar/',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppCheckinIndexRoute = AppCheckinIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCheckinLayoutRoute,
} as any)
const AppCaminhaoIndexRoute = AppCaminhaoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCaminhaoLayoutRoute,
} as any)
const AppAgendamentoIndexRoute = AppAgendamentoIndexRouteImport.update({
  id: '/agendamento/',
  path: '/agendamento/',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppPerfilEditarRoute = AppPerfilEditarRouteImport.update({
  id: '/editar',
  path: '/editar',
  getParentRoute: () => AppPerfilLayoutRoute,
} as any)
const AppPainelFilaRoute = AppPainelFilaRouteImport.update({
  id: '/painel/fila',
  path: '/painel/fila',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppLogsHistoricoRoute = AppLogsHistoricoRouteImport.update({
  id: '/historico',
  path: '/historico',
  getParentRoute: () => AppLogsLayoutRoute,
} as any)
const AppLogsExpiradosRoute = AppLogsExpiradosRouteImport.update({
  id: '/expirados',
  path: '/expirados',
  getParentRoute: () => AppLogsLayoutRoute,
} as any)
const AppCaminhaoNovoRoute = AppCaminhaoNovoRouteImport.update({
  id: '/novo',
  path: '/novo',
  getParentRoute: () => AppCaminhaoLayoutRoute,
} as any)
const AppAgendamentoStatusRoute = AppAgendamentoStatusRouteImport.update({
  id: '/agendamento/status',
  path: '/agendamento/status',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AuthExpedicaoLoginRoute = AuthExpedicaoLoginRouteImport.update({
  id: '/expedicao/login',
  path: '/expedicao/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAppLoginRoute = AuthAppLoginRouteImport.update({
  id: '/app/login',
  path: '/app/login',
  getParentRoute: () => AuthRoute,
} as any)
const AppCaminhaoEditarIndexRoute = AppCaminhaoEditarIndexRouteImport.update({
  id: '/editar/',
  path: '/editar/',
  getParentRoute: () => AppCaminhaoLayoutRoute,
} as any)
const AprovarTermoEmpresaCompanyIdDriverIdRoute =
  AprovarTermoEmpresaCompanyIdDriverIdRouteImport.update({
    id: '/aprovar-termo/empresa/$companyId/$driverId',
    path: '/aprovar-termo/empresa/$companyId/$driverId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppCaminhaoEditarIdRoute = AppCaminhaoEditarIdRouteImport.update({
  id: '/editar/$id',
  path: '/editar/$id',
  getParentRoute: () => AppCaminhaoLayoutRoute,
} as any)
const AuthAppRegistroIdRoute = AuthAppRegistroIdRouteImport.update({
  id: '/app/registro/$id',
  path: '/app/registro/$id',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppLayoutRouteWithChildren
  '/expedicao': typeof ExpedicaoLayoutRouteWithChildren
  '/tv': typeof TvLayoutRouteWithChildren
  '/403': typeof R403Route
  '/503': typeof R503Route
  '/app/caminhao': typeof AppCaminhaoLayoutRouteWithChildren
  '/app/checkin': typeof AppCheckinLayoutRouteWithChildren
  '/app/logs': typeof AppLogsLayoutRouteWithChildren
  '/app/perfil': typeof AppPerfilLayoutRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/expedicao/': typeof ExpedicaoIndexRoute
  '/tv/': typeof TvIndexRoute
  '/app/login': typeof AuthAppLoginRoute
  '/expedicao/login': typeof AuthExpedicaoLoginRoute
  '/app/agendamento/status': typeof AppAgendamentoStatusRoute
  '/app/caminhao/novo': typeof AppCaminhaoNovoRoute
  '/app/logs/expirados': typeof AppLogsExpiradosRoute
  '/app/logs/historico': typeof AppLogsHistoricoRoute
  '/app/painel/fila': typeof AppPainelFilaRoute
  '/app/perfil/editar': typeof AppPerfilEditarRoute
  '/app/agendamento/': typeof AppAgendamentoIndexRoute
  '/app/caminhao/': typeof AppCaminhaoIndexRoute
  '/app/checkin/': typeof AppCheckinIndexRoute
  '/app/como-chegar/': typeof AppComoChegarIndexRoute
  '/app/fila/': typeof AppFilaIndexRoute
  '/app/logs/': typeof AppLogsIndexRoute
  '/app/perfil/': typeof AppPerfilIndexRoute
  '/app/registro/$id': typeof AuthAppRegistroIdRoute
  '/app/caminhao/editar/$id': typeof AppCaminhaoEditarIdRoute
  '/aprovar-termo/empresa/$companyId/$driverId': typeof AprovarTermoEmpresaCompanyIdDriverIdRoute
  '/app/caminhao/editar/': typeof AppCaminhaoEditarIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/503': typeof R503Route
  '/app': typeof AppIndexRoute
  '/expedicao': typeof ExpedicaoIndexRoute
  '/tv': typeof TvIndexRoute
  '/app/login': typeof AuthAppLoginRoute
  '/expedicao/login': typeof AuthExpedicaoLoginRoute
  '/app/agendamento/status': typeof AppAgendamentoStatusRoute
  '/app/caminhao/novo': typeof AppCaminhaoNovoRoute
  '/app/logs/expirados': typeof AppLogsExpiradosRoute
  '/app/logs/historico': typeof AppLogsHistoricoRoute
  '/app/painel/fila': typeof AppPainelFilaRoute
  '/app/perfil/editar': typeof AppPerfilEditarRoute
  '/app/agendamento': typeof AppAgendamentoIndexRoute
  '/app/caminhao': typeof AppCaminhaoIndexRoute
  '/app/checkin': typeof AppCheckinIndexRoute
  '/app/como-chegar': typeof AppComoChegarIndexRoute
  '/app/fila': typeof AppFilaIndexRoute
  '/app/logs': typeof AppLogsIndexRoute
  '/app/perfil': typeof AppPerfilIndexRoute
  '/app/registro/$id': typeof AuthAppRegistroIdRoute
  '/app/caminhao/editar/$id': typeof AppCaminhaoEditarIdRoute
  '/aprovar-termo/empresa/$companyId/$driverId': typeof AprovarTermoEmpresaCompanyIdDriverIdRoute
  '/app/caminhao/editar': typeof AppCaminhaoEditarIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppLayoutRouteWithChildren
  '/expedicao': typeof ExpedicaoLayoutRouteWithChildren
  '/tv': typeof TvLayoutRouteWithChildren
  '/403': typeof R403Route
  '/503': typeof R503Route
  '/_auth': typeof AuthRouteWithChildren
  '/app/caminhao': typeof AppCaminhaoLayoutRouteWithChildren
  '/app/checkin': typeof AppCheckinLayoutRouteWithChildren
  '/app/logs': typeof AppLogsLayoutRouteWithChildren
  '/app/perfil': typeof AppPerfilLayoutRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/expedicao/': typeof ExpedicaoIndexRoute
  '/tv/': typeof TvIndexRoute
  '/_auth/app/login': typeof AuthAppLoginRoute
  '/_auth/expedicao/login': typeof AuthExpedicaoLoginRoute
  '/app/agendamento/status': typeof AppAgendamentoStatusRoute
  '/app/caminhao/novo': typeof AppCaminhaoNovoRoute
  '/app/logs/expirados': typeof AppLogsExpiradosRoute
  '/app/logs/historico': typeof AppLogsHistoricoRoute
  '/app/painel/fila': typeof AppPainelFilaRoute
  '/app/perfil/editar': typeof AppPerfilEditarRoute
  '/app/agendamento/': typeof AppAgendamentoIndexRoute
  '/app/caminhao/': typeof AppCaminhaoIndexRoute
  '/app/checkin/': typeof AppCheckinIndexRoute
  '/app/como-chegar/': typeof AppComoChegarIndexRoute
  '/app/fila/': typeof AppFilaIndexRoute
  '/app/logs/': typeof AppLogsIndexRoute
  '/app/perfil/': typeof AppPerfilIndexRoute
  '/_auth/app/registro/$id': typeof AuthAppRegistroIdRoute
  '/app/caminhao/editar/$id': typeof AppCaminhaoEditarIdRoute
  '/aprovar-termo/empresa/$companyId/$driverId': typeof AprovarTermoEmpresaCompanyIdDriverIdRoute
  '/app/caminhao/editar/': typeof AppCaminhaoEditarIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/expedicao'
    | '/tv'
    | '/403'
    | '/503'
    | '/app/caminhao'
    | '/app/checkin'
    | '/app/logs'
    | '/app/perfil'
    | '/app/'
    | '/expedicao/'
    | '/tv/'
    | '/app/login'
    | '/expedicao/login'
    | '/app/agendamento/status'
    | '/app/caminhao/novo'
    | '/app/logs/expirados'
    | '/app/logs/historico'
    | '/app/painel/fila'
    | '/app/perfil/editar'
    | '/app/agendamento/'
    | '/app/caminhao/'
    | '/app/checkin/'
    | '/app/como-chegar/'
    | '/app/fila/'
    | '/app/logs/'
    | '/app/perfil/'
    | '/app/registro/$id'
    | '/app/caminhao/editar/$id'
    | '/aprovar-termo/empresa/$companyId/$driverId'
    | '/app/caminhao/editar/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/503'
    | '/app'
    | '/expedicao'
    | '/tv'
    | '/app/login'
    | '/expedicao/login'
    | '/app/agendamento/status'
    | '/app/caminhao/novo'
    | '/app/logs/expirados'
    | '/app/logs/historico'
    | '/app/painel/fila'
    | '/app/perfil/editar'
    | '/app/agendamento'
    | '/app/caminhao'
    | '/app/checkin'
    | '/app/como-chegar'
    | '/app/fila'
    | '/app/logs'
    | '/app/perfil'
    | '/app/registro/$id'
    | '/app/caminhao/editar/$id'
    | '/aprovar-termo/empresa/$companyId/$driverId'
    | '/app/caminhao/editar'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/expedicao'
    | '/tv'
    | '/403'
    | '/503'
    | '/_auth'
    | '/app/caminhao'
    | '/app/checkin'
    | '/app/logs'
    | '/app/perfil'
    | '/app/'
    | '/expedicao/'
    | '/tv/'
    | '/_auth/app/login'
    | '/_auth/expedicao/login'
    | '/app/agendamento/status'
    | '/app/caminhao/novo'
    | '/app/logs/expirados'
    | '/app/logs/historico'
    | '/app/painel/fila'
    | '/app/perfil/editar'
    | '/app/agendamento/'
    | '/app/caminhao/'
    | '/app/checkin/'
    | '/app/como-chegar/'
    | '/app/fila/'
    | '/app/logs/'
    | '/app/perfil/'
    | '/_auth/app/registro/$id'
    | '/app/caminhao/editar/$id'
    | '/aprovar-termo/empresa/$companyId/$driverId'
    | '/app/caminhao/editar/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppLayoutRoute: typeof AppLayoutRouteWithChildren
  ExpedicaoLayoutRoute: typeof ExpedicaoLayoutRouteWithChildren
  TvLayoutRoute: typeof TvLayoutRouteWithChildren
  R403Route: typeof R403Route
  R503Route: typeof R503Route
  AuthRoute: typeof AuthRouteWithChildren
  AprovarTermoEmpresaCompanyIdDriverIdRoute: typeof AprovarTermoEmpresaCompanyIdDriverIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/503': {
      id: '/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof R503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tv': {
      id: '/tv'
      path: '/tv'
      fullPath: '/tv'
      preLoaderRoute: typeof TvLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expedicao': {
      id: '/expedicao'
      path: '/expedicao'
      fullPath: '/expedicao'
      preLoaderRoute: typeof ExpedicaoLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tv/': {
      id: '/tv/'
      path: '/'
      fullPath: '/tv/'
      preLoaderRoute: typeof TvIndexRouteImport
      parentRoute: typeof TvLayoutRoute
    }
    '/expedicao/': {
      id: '/expedicao/'
      path: '/'
      fullPath: '/expedicao/'
      preLoaderRoute: typeof ExpedicaoIndexRouteImport
      parentRoute: typeof ExpedicaoLayoutRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/perfil': {
      id: '/app/perfil'
      path: '/perfil'
      fullPath: '/app/perfil'
      preLoaderRoute: typeof AppPerfilLayoutRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/logs': {
      id: '/app/logs'
      path: '/logs'
      fullPath: '/app/logs'
      preLoaderRoute: typeof AppLogsLayoutRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/checkin': {
      id: '/app/checkin'
      path: '/checkin'
      fullPath: '/app/checkin'
      preLoaderRoute: typeof AppCheckinLayoutRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/caminhao': {
      id: '/app/caminhao'
      path: '/caminhao'
      fullPath: '/app/caminhao'
      preLoaderRoute: typeof AppCaminhaoLayoutRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/perfil/': {
      id: '/app/perfil/'
      path: '/'
      fullPath: '/app/perfil/'
      preLoaderRoute: typeof AppPerfilIndexRouteImport
      parentRoute: typeof AppPerfilLayoutRoute
    }
    '/app/logs/': {
      id: '/app/logs/'
      path: '/'
      fullPath: '/app/logs/'
      preLoaderRoute: typeof AppLogsIndexRouteImport
      parentRoute: typeof AppLogsLayoutRoute
    }
    '/app/fila/': {
      id: '/app/fila/'
      path: '/fila'
      fullPath: '/app/fila/'
      preLoaderRoute: typeof AppFilaIndexRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/como-chegar/': {
      id: '/app/como-chegar/'
      path: '/como-chegar'
      fullPath: '/app/como-chegar/'
      preLoaderRoute: typeof AppComoChegarIndexRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/checkin/': {
      id: '/app/checkin/'
      path: '/'
      fullPath: '/app/checkin/'
      preLoaderRoute: typeof AppCheckinIndexRouteImport
      parentRoute: typeof AppCheckinLayoutRoute
    }
    '/app/caminhao/': {
      id: '/app/caminhao/'
      path: '/'
      fullPath: '/app/caminhao/'
      preLoaderRoute: typeof AppCaminhaoIndexRouteImport
      parentRoute: typeof AppCaminhaoLayoutRoute
    }
    '/app/agendamento/': {
      id: '/app/agendamento/'
      path: '/agendamento'
      fullPath: '/app/agendamento/'
      preLoaderRoute: typeof AppAgendamentoIndexRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/perfil/editar': {
      id: '/app/perfil/editar'
      path: '/editar'
      fullPath: '/app/perfil/editar'
      preLoaderRoute: typeof AppPerfilEditarRouteImport
      parentRoute: typeof AppPerfilLayoutRoute
    }
    '/app/painel/fila': {
      id: '/app/painel/fila'
      path: '/painel/fila'
      fullPath: '/app/painel/fila'
      preLoaderRoute: typeof AppPainelFilaRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/app/logs/historico': {
      id: '/app/logs/historico'
      path: '/historico'
      fullPath: '/app/logs/historico'
      preLoaderRoute: typeof AppLogsHistoricoRouteImport
      parentRoute: typeof AppLogsLayoutRoute
    }
    '/app/logs/expirados': {
      id: '/app/logs/expirados'
      path: '/expirados'
      fullPath: '/app/logs/expirados'
      preLoaderRoute: typeof AppLogsExpiradosRouteImport
      parentRoute: typeof AppLogsLayoutRoute
    }
    '/app/caminhao/novo': {
      id: '/app/caminhao/novo'
      path: '/novo'
      fullPath: '/app/caminhao/novo'
      preLoaderRoute: typeof AppCaminhaoNovoRouteImport
      parentRoute: typeof AppCaminhaoLayoutRoute
    }
    '/app/agendamento/status': {
      id: '/app/agendamento/status'
      path: '/agendamento/status'
      fullPath: '/app/agendamento/status'
      preLoaderRoute: typeof AppAgendamentoStatusRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/_auth/expedicao/login': {
      id: '/_auth/expedicao/login'
      path: '/expedicao/login'
      fullPath: '/expedicao/login'
      preLoaderRoute: typeof AuthExpedicaoLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/app/login': {
      id: '/_auth/app/login'
      path: '/app/login'
      fullPath: '/app/login'
      preLoaderRoute: typeof AuthAppLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/app/caminhao/editar/': {
      id: '/app/caminhao/editar/'
      path: '/editar'
      fullPath: '/app/caminhao/editar/'
      preLoaderRoute: typeof AppCaminhaoEditarIndexRouteImport
      parentRoute: typeof AppCaminhaoLayoutRoute
    }
    '/aprovar-termo/empresa/$companyId/$driverId': {
      id: '/aprovar-termo/empresa/$companyId/$driverId'
      path: '/aprovar-termo/empresa/$companyId/$driverId'
      fullPath: '/aprovar-termo/empresa/$companyId/$driverId'
      preLoaderRoute: typeof AprovarTermoEmpresaCompanyIdDriverIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/caminhao/editar/$id': {
      id: '/app/caminhao/editar/$id'
      path: '/editar/$id'
      fullPath: '/app/caminhao/editar/$id'
      preLoaderRoute: typeof AppCaminhaoEditarIdRouteImport
      parentRoute: typeof AppCaminhaoLayoutRoute
    }
    '/_auth/app/registro/$id': {
      id: '/_auth/app/registro/$id'
      path: '/app/registro/$id'
      fullPath: '/app/registro/$id'
      preLoaderRoute: typeof AuthAppRegistroIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AppCaminhaoLayoutRouteChildren {
  AppCaminhaoNovoRoute: typeof AppCaminhaoNovoRoute
  AppCaminhaoIndexRoute: typeof AppCaminhaoIndexRoute
  AppCaminhaoEditarIdRoute: typeof AppCaminhaoEditarIdRoute
  AppCaminhaoEditarIndexRoute: typeof AppCaminhaoEditarIndexRoute
}

const AppCaminhaoLayoutRouteChildren: AppCaminhaoLayoutRouteChildren = {
  AppCaminhaoNovoRoute: AppCaminhaoNovoRoute,
  AppCaminhaoIndexRoute: AppCaminhaoIndexRoute,
  AppCaminhaoEditarIdRoute: AppCaminhaoEditarIdRoute,
  AppCaminhaoEditarIndexRoute: AppCaminhaoEditarIndexRoute,
}

const AppCaminhaoLayoutRouteWithChildren =
  AppCaminhaoLayoutRoute._addFileChildren(AppCaminhaoLayoutRouteChildren)

interface AppCheckinLayoutRouteChildren {
  AppCheckinIndexRoute: typeof AppCheckinIndexRoute
}

const AppCheckinLayoutRouteChildren: AppCheckinLayoutRouteChildren = {
  AppCheckinIndexRoute: AppCheckinIndexRoute,
}

const AppCheckinLayoutRouteWithChildren =
  AppCheckinLayoutRoute._addFileChildren(AppCheckinLayoutRouteChildren)

interface AppLogsLayoutRouteChildren {
  AppLogsExpiradosRoute: typeof AppLogsExpiradosRoute
  AppLogsHistoricoRoute: typeof AppLogsHistoricoRoute
  AppLogsIndexRoute: typeof AppLogsIndexRoute
}

const AppLogsLayoutRouteChildren: AppLogsLayoutRouteChildren = {
  AppLogsExpiradosRoute: AppLogsExpiradosRoute,
  AppLogsHistoricoRoute: AppLogsHistoricoRoute,
  AppLogsIndexRoute: AppLogsIndexRoute,
}

const AppLogsLayoutRouteWithChildren = AppLogsLayoutRoute._addFileChildren(
  AppLogsLayoutRouteChildren,
)

interface AppPerfilLayoutRouteChildren {
  AppPerfilEditarRoute: typeof AppPerfilEditarRoute
  AppPerfilIndexRoute: typeof AppPerfilIndexRoute
}

const AppPerfilLayoutRouteChildren: AppPerfilLayoutRouteChildren = {
  AppPerfilEditarRoute: AppPerfilEditarRoute,
  AppPerfilIndexRoute: AppPerfilIndexRoute,
}

const AppPerfilLayoutRouteWithChildren = AppPerfilLayoutRoute._addFileChildren(
  AppPerfilLayoutRouteChildren,
)

interface AppLayoutRouteChildren {
  AppCaminhaoLayoutRoute: typeof AppCaminhaoLayoutRouteWithChildren
  AppCheckinLayoutRoute: typeof AppCheckinLayoutRouteWithChildren
  AppLogsLayoutRoute: typeof AppLogsLayoutRouteWithChildren
  AppPerfilLayoutRoute: typeof AppPerfilLayoutRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppAgendamentoStatusRoute: typeof AppAgendamentoStatusRoute
  AppPainelFilaRoute: typeof AppPainelFilaRoute
  AppAgendamentoIndexRoute: typeof AppAgendamentoIndexRoute
  AppComoChegarIndexRoute: typeof AppComoChegarIndexRoute
  AppFilaIndexRoute: typeof AppFilaIndexRoute
}

const AppLayoutRouteChildren: AppLayoutRouteChildren = {
  AppCaminhaoLayoutRoute: AppCaminhaoLayoutRouteWithChildren,
  AppCheckinLayoutRoute: AppCheckinLayoutRouteWithChildren,
  AppLogsLayoutRoute: AppLogsLayoutRouteWithChildren,
  AppPerfilLayoutRoute: AppPerfilLayoutRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppAgendamentoStatusRoute: AppAgendamentoStatusRoute,
  AppPainelFilaRoute: AppPainelFilaRoute,
  AppAgendamentoIndexRoute: AppAgendamentoIndexRoute,
  AppComoChegarIndexRoute: AppComoChegarIndexRoute,
  AppFilaIndexRoute: AppFilaIndexRoute,
}

const AppLayoutRouteWithChildren = AppLayoutRoute._addFileChildren(
  AppLayoutRouteChildren,
)

interface ExpedicaoLayoutRouteChildren {
  ExpedicaoIndexRoute: typeof ExpedicaoIndexRoute
}

const ExpedicaoLayoutRouteChildren: ExpedicaoLayoutRouteChildren = {
  ExpedicaoIndexRoute: ExpedicaoIndexRoute,
}

const ExpedicaoLayoutRouteWithChildren = ExpedicaoLayoutRoute._addFileChildren(
  ExpedicaoLayoutRouteChildren,
)

interface TvLayoutRouteChildren {
  TvIndexRoute: typeof TvIndexRoute
}

const TvLayoutRouteChildren: TvLayoutRouteChildren = {
  TvIndexRoute: TvIndexRoute,
}

const TvLayoutRouteWithChildren = TvLayoutRoute._addFileChildren(
  TvLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthAppLoginRoute: typeof AuthAppLoginRoute
  AuthExpedicaoLoginRoute: typeof AuthExpedicaoLoginRoute
  AuthAppRegistroIdRoute: typeof AuthAppRegistroIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAppLoginRoute: AuthAppLoginRoute,
  AuthExpedicaoLoginRoute: AuthExpedicaoLoginRoute,
  AuthAppRegistroIdRoute: AuthAppRegistroIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppLayoutRoute: AppLayoutRouteWithChildren,
  ExpedicaoLayoutRoute: ExpedicaoLayoutRouteWithChildren,
  TvLayoutRoute: TvLayoutRouteWithChildren,
  R403Route: R403Route,
  R503Route: R503Route,
  AuthRoute: AuthRouteWithChildren,
  AprovarTermoEmpresaCompanyIdDriverIdRoute:
    AprovarTermoEmpresaCompanyIdDriverIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
